<hr style="margin: 0 18px" *ngIf="medias && medias.length > 0" />
<li *ngFor="let media of medias" [pTooltip]="displayTooltip ? media.Nom : null" container="body">
  <a [href]="media.Url" [target]="'_blank'" (click)="mediaClick(media)">
    <span class="menuitem-text">
      {{ label }}
      <aide [baseCode]="baseCodeAide" [code]="typeMediaId.toString()" *ngIf="typeMediaId"></aide>
    </span>
    <i class="fa fa-fw fa-info"></i>
  </a>
</li>
